import Alpine from 'alpinejs';
import {
    scrollToAnchor,
    hidePlaceholderTextArea,
    limitInputLength
} from './magics'
import './magics';
import searchModal from '../../../components/searchModal'
import newsletter from '../../../components/newsletter'
import stickyCtas from '../../../components/stickyCtas'
import quickLinksProduct from '../../../components/abTest/quickLinksProduct';
import expressAppointementToQuotation from '../../../components/abTest/expressAppointementToQuotation';
import exitIntentModal from '../../../components/abTest/exitIntentModal';
import quotationV1 from '../../../components/abTest/quotationV1';
import quotationToggleDetail from '../../../components/abTest/quotationToggleDetail';
import optinAndConsent from '../../../components/abTest/optinAndConsent';
import quotationV1Material from '../../../components/abTest/quotationMaterialStep';
import recapQuotationFormV1 from '../../../components/abTest/recapQuotationFormV1';
import skipCPstep from '../../../components/abTest/skipCPstep';
import skipProjectTypeQUotationForm from '../../../components/abTest/skipProjectTypeQUotationForm';
import quotationStickyRecap from '../../../components/abTest/quotationStickyRecap';

const globalStore = { 
    newsletterIsOpen: false,
    searchIsOpen: false,
    isMobile: false,
    breadcrumbMobile: false,
    init(): void {
        this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
        this.breadcrumbMobile = window.matchMedia('(max-width: 1024px)').matches;
    },
};

const scrollStore = {
    scrollY: 0, // number: distance scrollée depuis le haut de page
    scrollDown: false, // boolean: indique si l'utilisateur scroll down
    scrollUp: true,
    isScrollingUp: false,
};

const stickyStore = {
    startStickyCta: false,
    stickyBlock: true,
};

const abStore = {
    // AB test 86c5m05un - Link to quotation form with prefilled steps
    quickLinksProduct: false,
    quickLinksProductV3: false,
    // AB Test 86c5mdwbh - Quotation form instead of appointment
    appointmentFormChangedToQuotation: false,
    // AB test 86c4u3xqb - Exit intent modal
    isUserExiting: false,
    exitModalHasBeenClosed: localStorage.getItem('exitModalHasBeenClosed') === 'true',
    pageViews: parseInt(localStorage.getItem('pageViews') || '0', 10),
    // AB test 86c9ntj0b - Quotatipn v1 "votre demande en 2 mn" + avis vérifié dans le header du tunnel de devis
    showHeaderWordingAndReviews: false,
    // AB test 86c9nucr7 - Quotation detail coordonates
    quotationToggleDetailState: false,
    // AB test 86c9nuxjx - Quotation v1 material step as V2/V3
    quotationV1Material: false,
    // AB test 86c9nunuu - Pannel quotation v1 as quotation v2/3
    recapV2V3: false,
    // AB test 86c9nu241 - skip cp step
    skipCPstepState: false,
    // AB Test - 86c9ntpxg skip project-type step
    skipProjectType: false,
    // AB test ab-quotation-sticky-recap - Sticky recap header (mobile) avec étapes/réassurance/promo
    quotationStickyRecap: false,
    closeExitModal() {
        this.isUserExiting = false;
        this.exitModalHasBeenClosed = true;
        localStorage.setItem('exitModalHasBeenClosed', 'true');
    },
    // AB test 86c9nujqy - Opt-in and consent quotation
    optinAndConsentQuotationState: false
};

export interface AlpineStoresTryba { global: typeof globalStore, scroll: typeof scrollStore, sticky: typeof stickyStore, ab: typeof abStore }
export interface AlpineMagicsTryba<T> {
    $data: T;
    $el: HTMLElement;
    $refs: Record<string, HTMLElement>;
    $store: AlpineStoresTryba;
    $nextTick: (callback?: () => void) => Promise<void>;
    $watch: (property: string, callback: (newValue: any, oldValue: any) => void) => void;
    [key: string]: any;
}
export type AlpineComponentTryba<T = Record<string, any>> = T & { [key: string]: any } & ThisType<T & { [key: string]: any } & AlpineMagicsTryba<T>>;

document.addEventListener('click', (e) => {
    const link = (e.target as Element).closest('a[href^="#"]') as HTMLAnchorElement | null;
    if (!link) return;

    const anchor = link.getAttribute('href')?.slice(1);
    if (!anchor || !document.getElementById(anchor)) return;

    e.preventDefault();
    scrollToAnchor(anchor);
});

document.addEventListener('alpine:init', () => {
    Alpine.store('global', globalStore);
    Alpine.store('scroll', scrollStore);
    Alpine.store('sticky', stickyStore);
    Alpine.store('ab', abStore);

    Alpine.magic('scrollToAnchor', () => scrollToAnchor);
    Alpine.magic('hidePlaceholderTextArea', (el) => () => hidePlaceholderTextArea(el as HTMLElement));
    Alpine.magic('limitInputLength', (el) => (maxNumber = -1) => limitInputLength(el, maxNumber));

    Alpine.data('newsletter', newsletter);
    Alpine.data('searchModal', searchModal);
    Alpine.data('stickyCtas', stickyCtas);
    Alpine.data('quickLinksProduct', quickLinksProduct);
    Alpine.data('expressAppointementToQuotation', expressAppointementToQuotation);
    Alpine.data('exitIntentModal', exitIntentModal);
    Alpine.data('quotationV1', quotationV1);
    Alpine.data('quotationToggleDetail', quotationToggleDetail);
    Alpine.data('optinAndConsent', optinAndConsent);
    Alpine.data('quotationV1Material', quotationV1Material);
    Alpine.data('recapQuotationFormV1', recapQuotationFormV1);
    Alpine.data('skipCPstep', skipCPstep);
    Alpine.data('skipProjectTypeQUotationForm', skipProjectTypeQUotationForm);
    Alpine.data('quotationStickyRecap', quotationStickyRecap);
});
